export function Copy() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1507_2027)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 5.5C1 3.63077 1 2.69615 1.40192 2C1.66523 1.54394 2.04394 1.16523 2.5 0.901924C3.19615 0.5 4.13077 0.5 6 0.5C7.86923 0.5 8.80385 0.5 9.5 0.901924C9.95606 1.16523 10.3348 1.54394 10.5981 2C10.9626 2.63135 10.9965 3.45883 10.9997 5.00173C10.692 5 10.3599 5 10 5C7.66537 5 6.49805 5 5.61441 5.47231C4.9167 5.84525 4.34525 6.4167 3.97231 7.11441C3.57964 7.84905 3.51343 8.77976 3.50227 10.4143C3.09923 10.3566 2.78029 10.2599 2.5 10.0981C2.04394 9.83477 1.66523 9.45606 1.40192 9C1 8.30385 1 7.36923 1 5.5ZM5.40192 8C5 8.69615 5 9.63077 5 11.5C5 13.3692 5 14.3038 5.40192 15C5.66523 15.4561 6.04394 15.8348 6.5 16.0981C7.19615 16.5 8.13077 16.5 10 16.5C11.8692 16.5 12.8038 16.5 13.5 16.0981C13.9561 15.8348 14.3348 15.4561 14.5981 15C15 14.3038 15 13.3692 15 11.5C15 9.63077 15 8.69615 14.5981 8C14.3348 7.54394 13.9561 7.16523 13.5 6.90192C12.8038 6.5 11.8692 6.5 10 6.5C8.13077 6.5 7.19615 6.5 6.5 6.90192C6.04394 7.16523 5.66523 7.54394 5.40192 8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1507_2027">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
